import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@picflow/types';

@Pipe({
  name: 'assetStatusShortcut',
  standalone: true,
})
export class AssetStatusShortcutPipe implements PipeTransform {
  transform(status: AssetStatus): string {
    if (status === 'approved') return 'A';
    if (status === 'rejected') return 'X';
  }
}
